import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import TransactionReviewTab from "components/TransactionReviewTab";
import ManualTransactionReviewContext from "context/ManualTransactionReviewContext";
import { getTransactionUnderReviewAsync } from "state/slices/transaction";
import { getCompany } from "state/slices/company";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";

const ManualTransactionReview = () => {
  const isInManualTransactionReviewContext = true;
  const { trxId, companyId } = useParams();
  const dispatch = useDispatch();
  const urlString = window.location.search; // Gets the query string part of the URL
  const urlParams = new URLSearchParams(urlString);
  const isViewMode = false;
  const { transactionUnderReview, getTransactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const [status, setStatus] = useState(getTransactionUnderReview.status);
  useEffect(() => {
    dispatch(
      getTransactionUnderReviewAsync({
        trxId,
      })
    );
    dispatch(
      getCompany({
        companyId,
        queryparams: {
          isDashboard: true,
        },
      })
    );
  }, [trxId]);

  useEffect(() => {
    setStatus(getTransactionUnderReview.status);
  }, [getTransactionUnderReview.status]);

  if (status === "loading") {
    return (
      <>
        <CompanyDashboardWrapper>
          <SpinnerIcon />
        </CompanyDashboardWrapper>
      </>
    );
  }
  if (
    status === "succeeded" &&
    transactionUnderReview?.items?.transactions?.length > 0
  ) {
    return (
      <CompanyDashboardWrapper>
        <ManualTransactionReviewContext.Provider
          value={{ isInManualTransactionReviewContext }}
        >
          <TransactionReviewTab />
        </ManualTransactionReviewContext.Provider>
      </CompanyDashboardWrapper>
    );
  }
  if (status === "failed") {
    return (
      <>
        <span>Failed to get resources..</span>
      </>
    );
  }
  return <span>Idle...</span>;
};

export default ManualTransactionReview;
